<template>
	<div class="create">
		<navComponent/>
		<div class="container mt-4">
			<!-- <h4><b>
				<router-link to="/dashboard"><i class="fa fa-arrow-left" style="cursor: pointer;"></i></router-link>
				Create Event</b>
			</h4>
			<hr> -->
			<section class="signup-step-container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-8">
						<div class="wizard">
							<div class="wizard-inner">
								<div class="connecting-line"></div>
								<ul class="nav nav-tabs" role="tablist">
									<li role="presentation" id="step_option1" class="active">
										<a href="#step1" data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true"><span
														class="round-tab">1 </span> <i style="margin: 0px 15px">User details</i></a>
									</li>
									<li role="presentation" id="step_option2" class="">
										<a href="#step2" data-toggle="tab" aria-controls="step2" role="tab" aria-expanded="false"><span
														class="round-tab">2</span> <i style="margin: 0px 15px">Profile photo</i></a>
									</li>
									<li role="presentation" id="step_option3" class="">
										<a href="#step3" data-toggle="tab" aria-controls="step3" role="tab"><span class="round-tab">3</span>
											<i style="margin: 0px 15px">Social presence</i></a>
									</li>
								</ul>
							</div>
							<div class="tab-content" id="main_form">
								<div class="" v-if="step_form1" id="1" role="tabpanel">
									<h4 class="text-center">Your basic details</h4>
									<hr>
									<div class="row">
										<div class="col-md-12">
                                            <div class="form-group">
												<label>Name</label>
												<input class="form-control" type="text">
											</div>
											
										</div>
										<div class="col-md-12">
											<div class="form-group">
												<label>Email</label>
												<input class="form-control" type="text">
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Designation</label>
												<input class="form-control" type="text" v-model="data.designation" placeholder="Enter your current designation">
											</div>
										</div>
                                        <div class="col-md-6">
											<div class="form-group">
												<label>Company</label>
												<input class="form-control" type="text" v-model="data.company" placeholder="Enter your current company">
											</div>
										</div>
                                        <div class="col-md-6">
											<div class="form-group">
												<label>City</label>
												<input class="form-control" type="text" v-model="data.city" placeholder="Enter your current city">
											</div>
										</div>
                                        <div class="col-md-6">
											<div class="form-group">
												<label>Country</label>
												<input class="form-control" type="text" v-model="data.country" placeholder="Enter your current country">
											</div>
										</div>
                                        <div class="col-md-12">
											<div class="form-group">
												<label>Tell us about yourself</label>
												<vue-editor v-model="data.bio" :editorToolbar="customToolbar" placeholder="Tell us about yourself"></vue-editor>
											</div>
										</div>
									</div>
									<!--									<div class="alert alert-secondary">-->
									<!--										This event will be invite only, please copy the link and share with your targeted audience.-->
									<!--									</div>-->
									<ul class="list-inline text-center">
										<li>
											<button type="button" @click="steps_submit1()" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
								</div>
								<div class="" v-if="step_form2" id="2" role="tabpanel">
									<h4 class="text-center">Upload profile photo</h4>
									<hr>
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<div class="form-group" v-if="this.data.photoURL === ''">
												<label>Upload Profile photo</label>
												<vue-dropzone
																ref="myVueDropzone"
																:options="dropzoneOptions"
																:awss3="awss3"
																v-on:vdropzone-s3-upload-error="s3UploadError"
																v-on:vdropzone-s3-upload-success="s3UploadSuccess"
																id="dropzone"
																v-on:vdropzone-file-added="vfileAdded" style="background: #1B1B1B">
												</vue-dropzone>
											</div>
											<div class="form-group" v-else>
												<label>Your choosen profile pic</label>
												<img :src="this.data.image" style="width: 100%;" :alt="this.data.title">
											</div> 
											</div>
										</div>
									</div>
									<ul class="list-inline text-center">
										<li>
											<button type="button" @click="steps_submit2" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
								</div>
								<div v-if="step_form3" role="tabpanel">
									<h4 class="text-center">Tell us your social presence</h4>
									<hr>
									<div class="form-group">
                                        <label>Facebook</label>
                                        <input class="form-control" type="text" v-model="data.fb_url" placeholder="Enter your Facebook account link">
                                    </div>
									<div class="form-group">
                                        <label>Linkedin</label>
                                        <input class="form-control" type="text" v-model="data.linkedin_url" placeholder="Enter your Linkedin account link">
                                    </div>
									<div class="form-group">
                                        <label>Twitter</label>
                                        <input class="form-control" type="text" v-model="data.twitter_url" placeholder="Enter your Twitter account link">
                                    </div>
									<ul class="list-inline text-center">
										<li>
											<button type="button" @click="steps_submit3()" class="btn btn-primary text-dark"><b>Submit</b></button>
										</li>
									</ul>
								</div>
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
  import navComponent from '@/components/nav.vue'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
//   import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {VueEditor} from "vue2-editor";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  export default {
    name: 'create',
    data() {
      return {
        user: JSON.parse(localStorage.getItem('user_info')),
        customToolbar: [[{'header': [false, 1, 2, 3, 4, 5, 6,]}], ["bold", "italic", "underline"], [{list: "ordered"}, {list: "bullet"}]],
        data: {
          designation: "NA",
          photoURL: "",
          company: "NA",
          city: "",
          country: "",
          bio: "",
          fb_url: "",
          twitter_url: "",
          linkedin_url: "",
        },
        step_form1: true,
        step_form2: false,
        step_form3: false,
        showTimePanel: false,
        showTimeRangePanel: false,
        baseUrl: this.$store.state.baseUrl,
        dropzoneOptions: {
          url: "https://httpbin.org/post",
          maxFilesize: 10,
          maxFiles: 1,
          acceptedFiles: "image/*",
          params: {
            success_action_status: 201
          },
          addRemoveLinks: true,
          headers: {'Access-Control-Allow-Origin': '*'}
        },
        awss3: {
          signingURL: this.baseUrl + "/signature", //Where you will get signed url
          headers: {},
          params: {},
          sendFileToServer: true, //If you want to upload file to your server along with s3
          withCredentials: false
        },
      }
    },
    components: {
      navComponent,
      vueDropzone: vue2Dropzone,
      VueEditor
    },
    created() {
      if (this.user.is_admin === false) {
        this.$router.push('/home')
      }
    },
    methods: {
      vfileAdded(file) {
        console.log(file)
        let file_name = file.name
        this.awss3.signingURL = this.baseUrl + "/signature/" + file_name
        this.dropzoneOptions.url = this.baseUrl + "/signature/" + file_name
      },
      s3UploadError(errorMessage) {
        console.log(errorMessage)
      },
      s3UploadSuccess(s3ObjectLocation) {
        this.data.image = s3ObjectLocation
      },
      step_nav: function (id) {
        if (id === 1) {
          document.getElementById('step_option1').classList.add('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.remove('active')
          this.step_form1 = true
          this.step_form2 = false
          this.step_form3 = false
        } else if (id === 2) {
          document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.add('active')
          document.getElementById('step_option3').classList.remove('active')
          this.step_form1 = false
          this.step_form2 = true
          this.step_form3 = false
        } else if (id === 3) {
          document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.add('active')
          this.step_form1 = false
          this.step_form2 = false
          this.step_form3 = true
        }
      },
      steps_submit1: function () {
          this.step_nav(2)
      },
      steps_submit2: function () {
        this.step_nav(3)
      },
      steps_submit3: function () {
        const $ = this
        console.log($.data);
        
      },

    }
  }
</script>
<style scoped>
	/*------------------------*/
	input:focus,
	button:focus,
	.form-control:focus {
		outline: none;
		box-shadow: none;
	}

	.form-control:disabled, .form-control[readonly] {
		background-color: #fff;
	}

	/*----------step-wizard------------*/
	.d-flex {
		display: flex;
	}

	.justify-content-center {
		justify-content: center;
	}

	.align-items-center {
		align-items: center;
	}

	/*---------signup-step-------------*/
	.bg-color {
		background-color: #333;
	}

	.signup-step-container {
		padding: 50px 0px;
		padding-bottom: 60px;
	}

	.wizard .nav-tabs {
		position: relative;
		margin-bottom: 0;
		border-bottom-color: transparent;
	}

	.wizard > div.wizard-inner {
		position: relative;
		margin-bottom: 50px;
		text-align: center;
	}

	.connecting-line {
		height: 2px;
		background: #1B1B1B;
		position: absolute;
		width: 66%;
		margin: 0 auto;
		left: 0;
		right: 0;
		top: 15px;
		z-index: 1;
	}

	.wizard .nav-tabs > li.active > a, .wizard .nav-tabs > li.active > a:hover, .wizard .nav-tabs > li.active > a:focus {
		color: #555555;
		cursor: default;
		border: 0;
		border-bottom-color: transparent;
	}

	span.round-tab {
		width: 30px;
		height: 30px;
		line-height: 30px;
		display: inline-block;
		border-radius: 50%;
		background: #1B1B1B;
		z-index: 2;
		position: absolute;
		left: 0;
		text-align: center;
		font-size: 16px;
		color: #fff;
		font-weight: 500;
		border: 1px solid #ddd;
	}

	span.round-tab i {
		color: #555555;
	}

	.wizard li.active span.round-tab {
		background: #FFB229;
		color: #fff;
		border-color: #F57F17;
	}

	.wizard li.active span.round-tab i {
		color: #5bc0de;
	}

	.wizard .nav-tabs > li.active > a i {
		color: #FFB229;
	}

	.wizard .nav-tabs > li {
		width: 33.33%;
	}

	.wizard li:after {
		content: " ";
		position: absolute;
		left: 46%;
		opacity: 0;
		margin: 0 auto;
		bottom: 0px;
		border: 5px solid transparent;
		border-bottom-color: red;
		transition: 0.1s ease-in-out;
	}


	.wizard .nav-tabs > li a {
		width: 30px;
		height: 30px;
		margin: 20px auto;
		border-radius: 100%;
		padding: 0;
		background-color: transparent;
		position: relative;
		top: 0;
	}

	.wizard .nav-tabs > li a i {
		position: absolute;
		top: -15px;
		font-style: normal;
		font-weight: 400;
		white-space: nowrap;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 12px;
		font-weight: 700;
		color: #fff;
	}

	.wizard .nav-tabs > li a:hover {
		background: transparent;
	}

	.wizard .tab-pane {
		position: relative;
		padding-top: 20px;
	}


	.wizard h3 {
		margin-top: 0;
	}

	.prev-step,
	.next-step {
		font-size: 13px;
		padding: 8px 24px;
		border: none;
		border-radius: 4px;
		margin-top: 30px;
	}

	.next-step {
		background-color: #0db02b;
	}

	.skip-btn {
		background-color: #cec12d;
	}

	.step-head {
		font-size: 20px;
		text-align: center;
		font-weight: 500;
		margin-bottom: 20px;
	}

	.term-check {
		font-size: 14px;
		font-weight: 400;
	}

	.custom-file {
		position: relative;
		display: inline-block;
		width: 100%;
		height: 40px;
		margin-bottom: 0;
	}

	.custom-file-input {
		position: relative;
		z-index: 2;
		width: 100%;
		height: 40px;
		margin: 0;
		opacity: 0;
	}

	.custom-file-label {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		z-index: 1;
		height: 40px;
		padding: .375rem .75rem;
		font-weight: 400;
		line-height: 2;
		color: #495057;
		background-color: #fff;
		border: 1px solid #ced4da;
		border-radius: .25rem;
	}

	.custom-file-label::after {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 3;
		display: block;
		height: 38px;
		padding: .375rem .75rem;
		line-height: 2;
		color: #495057;
		content: "Browse";
		background-color: #e9ecef;
		border-left: inherit;
		border-radius: 0 .25rem .25rem 0;
	}

	.footer-link {
		margin-top: 30px;
	}

	.all-info-container {

	}

	.list-content {
		margin-bottom: 10px;
	}

	.list-content a {
		padding: 10px 15px;
		width: 100%;
		display: inline-block;
		background-color: #f5f5f5;
		position: relative;
		color: #565656;
		font-weight: 400;
		border-radius: 4px;
	}

	.list-content a[aria-expanded="true"] i {
		transform: rotate(180deg);
	}

	.list-content a i {
		text-align: right;
		position: absolute;
		top: 15px;
		right: 10px;
		transition: 0.5s;
	}

	.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
		background-color: #fdfdfd;
	}

	.list-box {
		padding: 10px;
	}

	.signup-logo-header .logo_area {
		width: 200px;
	}

	.signup-logo-header .nav > li {
		padding: 0;
	}

	.signup-logo-header .header-flex {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.list-inline li {
		display: inline-block;
	}

	.pull-right {
		float: right;
	}

	/*-----------custom-checkbox-----------*/
	/*----------Custom-Checkbox---------*/
	input[type="checkbox"] {
		position: relative;
		display: inline-block;
		margin-right: 5px;
	}

	input[type="checkbox"]::before,
	input[type="checkbox"]::after {
		position: absolute;
		content: "";
		display: inline-block;
	}

	input[type="checkbox"]::before {
		height: 16px;
		width: 16px;
		border: 1px solid #999;
		left: 0px;
		top: 0px;
		background-color: #fff;
		border-radius: 2px;
	}

	input[type="checkbox"]::after {
		height: 5px;
		width: 9px;
		left: 4px;
		top: 4px;
	}

	input[type="checkbox"]:checked::after {
		content: "";
		border-left: 1px solid #fff;
		border-bottom: 1px solid #fff;
		transform: rotate(-45deg);
	}

	input[type="checkbox"]:checked::before {
		background-color: #18ba60;
		border-color: #18ba60;
	}

	@media (max-width: 767px) {
		.sign-content h3 {
			font-size: 40px;
		}

		.wizard .nav-tabs > li a i {
			display: none;
		}

		.signup-logo-header .navbar-toggle {
			margin: 0;
			margin-top: 8px;
		}

		.signup-logo-header .logo_area {
			margin-top: 0;
		}

		.signup-logo-header .header-flex {
			display: block;
		}
	}

</style>
